/// <summary>
/// This object does the complete menu and highchart handling in the sankey. <br/>
/// It generates proper ramp and ramp signal parameters, does the date handling and menu hiding/showing stuff. 
/// Author: MWI<br />
/// Date: 5.10.2015<br />
/// Copyright ©: EUDT GmbH 2015 <br />
/// Version-History:<br />
/// *** v1.0.3 - 26.01.2017                                             *<br />
/// **********************************************************************<br />
/// * -removed the filtering                                             *<br />
/// **********************************************************************<br />
/// *** v1.0.3 - 26.01.2017                                             *<br />
/// **********************************************************************<br />
/// * - generateChartParameter updated to reflect change in archive menu *<br />
/// **********************************************************************<br />
/// *** v1.0.2 - 10.03.2016                                                *<br />
/// **********************************************************************<br />
/// * -  small change for price showing                                  *<br />
/// **********************************************************************<br />
/// *** v1.0.1 - 24.11.2015                                                *<br />
/// **********************************************************************<br />
/// * -  documentation and changed for vcTemplate                        *<br />
/// **********************************************************************<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 5.10.2015                                                *<br />
/// **********************************************************************<br />
/// * -  inherited from rampMenu js                                      *<br />
/// * -  changed only a few functions                                    *<br />
/// **********************************************************************<br />
/// </summary>

function sankeyMenu(visual, vcid, vcgid, userLangid) {
    ///<summary>
    ///creates the Object by simply calling the "super" constructor
    ///</summary>
    this.userLangid = userLangid;
    this.bInit = false;
    window.rampMenu.call(this, visual, vcid, vcgid);
}

//create the prototype based on the rampMenu Object
sankeyMenu.prototype = Object.create(window.rampMenu.prototype);

//set the constructor to this object
sankeyMenu.prototype.constructor = sankeyMenu;

sankeyMenu.prototype.overrideShowButton = function(eventName) {
    ///<summary>
    ///This function overrides the reload chart button <br/>
    ///it simply changes the click handler and lets it send a own event
    ///</summary>
    var me = this;
    try {
        me.visual.find('#btnShowChart').unbind("click").bind("click",
            function() {
                window._VCMQ.produce(me.visual, me.vcgid, eventName, '');
            });
    } catch (ex) {
        window.writeError('sankeyMenu.js.overrideShowButton', ex);
        return false;
    }
    return false;
};
sankeyMenu.prototype.initUserOptions = function() {
    ///<summary>
    ///empty user options function to avoid errors
    ///</summary>
};
sankeyMenu.prototype.generateChartParameter = function () {
    /// <summary>
    /// Override of rampMenu.generateChartParameter <br/>
    /// first calls the Method of the Base Class <br/>
    /// simplifies the signalparameter to a single bsaid
    /// and sets cumulated to always true
    /// </summary>
    var me = this;
    var dates;
    try {
        me.rampCharts.getSelectedMenuType = function() { return 0; };
        window.rampMenu.prototype.generateChartParameter.call(me);



        dates = $("#div-date-box").vcFullDateBox("getDate");
        me.param.startDate = dates.from;
        me.param.endDate = dates.to;
        if ($("#div-date-box").vcFullDateBox("getIndex") === 1) {
            me.param.dateUserDef = true;
        }

        me.param.StartingHour = 0;
        //me.visual.find('#divVisualcore' + me.vcid).height(1500);
        me.chartWidth = parseInt($("#divRamp1").width() - 330, 10);
        //me.visual.find('#divRamp' + me.vcid).height(1500);
        me.chartHeightSingle = parseInt(1000, 10);

        me.param.isCumulated = true;
        me.param.datatype = 2;
        me.param.usePrices = me.visual.find('#selUsePrice').hasClass('ui-selected');
        window._VCMQ.produce(me.visual, me.vcgid, 'sankey_toggle_price', { bShowPrice: me.usePrice });
       // me.signalParam = {};
       // me.signalParam.bsaid = me.visual.find(".selected").attr('data-id');
    } catch (ex) {
        window.writeError("sankeyMenuGenerateChartParameter", ex);
    }
};
sankeyMenu.prototype.getVisualName = function() {
    /// <summary>
    /// This function returns the visual name based on the selected time interval.<br/>
    /// OVERLOAD OF rampMenu
    /// </summary>
    return "VISUAL_SIGNAL_SANKEY";

};
sankeyMenu.prototype.overridePriceAndCumlulatedOption = function() {
    ///<summary>
    ///Overrides the option for Price and Cumulated to be fixed <br/>
    ///sets both options to be always used 
    ///</summary>
    var me = this;
    try {
        me.visual.find(".submenu .ui-widget-content").unbind("click");
        me.visual.find('#selUsePrice').unbind("click").bind("click",
            function() {
                window.rampMenu.prototype.setDirty.call(me, true);
                $(this).toggleClass("ui-selected");
                if ($(this).hasClass('ui-selected')) {
                    me.visual.find('#selUsePrice i').show();
                    me.usePrice = true;
                } else {
                    me.visual.find('#selUsePrice i').hide();
                    me.usePrice = false;
                }
                me.param.usePrices = me.usePrice;

                window._VCMQ.produce(me.visual, me.vcgid, 'sankey_toggle_price', { bShowPrice: me.usePrice });
            }
        );
    } catch (ex) {
        window.writeError("sankeyMenu.overridePriceAndCumlulatedOption", ex);

    }

};
sankeyMenu.prototype.createButtons = function() {
    var me = this;
    try {
        me.visual.find("#btnReset").off("click").on("click",
            function() {
                window._VCMQ.produce(me.visual, me.vcgid, 'topo_reset_view');

            });
       
        me.visual.find("#btnFullscreen").off("click").on("click",
            function() {
                $(this).toggleClass('button-active');
                window._VCMQ.produce(me.visual, me.vcgid, 'topo_full_screen');

            });
    } catch (ex) {
        window.writeError("sankeyMenu.createButtons", ex);
    }
};
// ReSharper disable once UnusedParameter
sankeyMenu.prototype.events = function() {
    ///<summary>
    ///Empty function body to avoid errors 
    ///</summary>
};


sankeyMenu.prototype.initDateBox = function () {
    /// <summary>
    /// inits the vcFullDateBox
    /// </summary>
    var me = this;
    try {
     
        $("#div-date-box").vcFullDateBox({
            langID: me.userLangid, callback: function () {
                window.rampMenu.prototype.setDirty.call(me, true);
                me.bInit = true;
            }
        });

    } catch (ex) {
        window.writeError('sankeyMenu.js.initDateBox', ex);
        return false;
    }
    return false;
};


sankeyMenu.prototype.changeDateBox = function (inter) {
    /// <summary>
    /// resets the interval and reloads the vcFullDateBox
    /// </summary>
    try {
        $("#div-date-box").vcFullDateBox("option", "interval", inter);
        $("#div-date-box").vcFullDateBox("refresh");
    } catch (ex) {
        window.writeError('sankeyMenu.js.changeDateBox', ex);
        return false;
    }
    return false;
};


sankeyMenu.prototype.setInterval = function () {
    var me = this;
    try {

        window.rampMenu.prototype.setInterval.call(me);

        if (me.bInit) {
            me.changeDateBox(me.interval);
        }
  
        me.visual.find(".vc-list-item").filter(function (idx, element) {
            return parseInt($(element).data("interval"), 10) > parseInt(me.interval, 10);
        }).addClass("inactive").find(".fa-eye-slash").show();
        me.visual.find(".vc-list-item").filter(function (idx, element) {
            return !(parseInt($(element).data("interval"), 10) > parseInt(me.interval, 10));
        }).removeClass("inactive").find(".fa-eye-slash").hide();
    } catch (ex) {
        window.writeError('sankeyMenu.setInterval', ex);
    }

};

